import CategoriesDnd from './CategoriesDnd';

export default CategoriesDnd;